<template>
  <div>
    <EmailConfigForm @submit="addConfiguration"/>
  </div>
</template>
<script>
  import EmailConfigForm from './EmailConfigForm'
  import EmailConfigService from 'src/services/EmailConfigService'
  export default {
    components: {
      EmailConfigForm
    },
    methods: {
      async addConfiguration(data) {
        await EmailConfigService.create(data)
        this.$router.push({ name: 'settings_email-configuration' })
      }
    }
  }
</script>
<style>
</style>
